import { useTheme } from '@material-ui/core/styles'
import React from 'react'
import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import CustomTooltip from './CustomTooltip'

export function SmallPie({ chartData }) {
  const theme = useTheme()

  return (
    <div style={{ width: '120px', height: '120px' }}>
      <ResponsiveContainer>
        <PieChart>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            innerRadius="70%"
            outerRadius="80%"
            fill={theme.palette.blue_300.main}
            dataKey="value"
            stroke="none"
          >
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} stroke="none" />
            ))}
          </Pie>
          <Tooltip content={<CustomTooltip />} cursor={true} />
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}
